import { render, staticRenderFns } from "./modify-parameter.vue?vue&type=template&id=29a8b527&scoped=true"
import script from "./modify-parameter.vue?vue&type=script&lang=ts"
export * from "./modify-parameter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a8b527",
  null
  
)

export default component.exports